import { ActionMeta } from 'chakra-react-select'
import { Controller, useFormContext } from 'react-hook-form'

import {
  Dropdown,
  DropdownOption,
  DropdownProps,
} from 'components/Inputs/Dropdown/Dropdown'

export const FormDropdown = ({
  id,
  externalOnChange,
  options,
  ...rest
}: DropdownProps & {
  externalOnChange?: (
    newValue: DropdownOption | DropdownOption[] | null,
    actionMeta: ActionMeta<unknown>
  ) => void
}) => {
  const { control, trigger } = useFormContext()

  return (
    <Controller
      name={id}
      control={control}
      render={({ field }) => (
        <Dropdown
          id={id}
          ref={field.ref}
          value={field.value}
          onChange={(newValue, actionMeta) => {
            field.onChange(newValue)
            externalOnChange?.(newValue, actionMeta)
            if (actionMeta.action === 'select-option') {
              trigger(id)
            }
          }}
          onBlur={field.onBlur}
          options={options}
          {...rest}
        />
      )}
    />
  )
}
